"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Application = exports.ApplicationTopic = void 0;
const api_1 = require("./api");
const structs_1 = require("./structs");
const utils_1 = require("./utils");
const mqtt_1 = __importDefault(require("mqtt"));
const uuid_1 = require("uuid");
var ApplicationTopic;
(function (ApplicationTopic) {
    ApplicationTopic["Root"] = "palletizer/";
    ApplicationTopic["Version"] = "palletizer/version";
    ApplicationTopic["Machines"] = "palletizer/machines";
    ApplicationTopic["MachineSafety"] = "palletizer/safety/#"; /* (component/machine)_name */
    ApplicationTopic["Control"] = "palletizer/control";
    ApplicationTopic["State"] = "palletizer/state";
    ApplicationTopic["Information"] = "palletizer/information";
    ApplicationTopic["AppendInformation"] = "palletizer/information/append";
    ApplicationTopic["StateRequest"] = "palletizer/request";
    ApplicationTopic["Robot"] = "palletizer/robot_state";
    ApplicationTopic["Alert"] = "palletizer/alert";
    ApplicationTopic["AccessRequest"] = "accessrequest";
    ApplicationTopic["Queue"] = "palletizer/run/queue";
    ApplicationTopic["OperationalState"] = "palletizer/operationalState";
    ApplicationTopic["SystemState"] = "palletizer/systemState";
    ApplicationTopic["Estop"] = "palletizer/estop";
    ApplicationTopic["PalletizerMode"] = "palletizer/manualModeOn";
    ApplicationTopic["PalletizerIOs"] = "palletizer/ios";
    ApplicationTopic["PendingSKUScan"] = "palletizer/pendingSKUScan";
    ApplicationTopic["InvalidSKUScan"] = "palletizer/invalidSKUScan";
    ApplicationTopic["BoxErectorPower"] = "boxerector/robot_power/state";
    ApplicationTopic["BoxErectorControl"] = "boxerector/control";
    ApplicationTopic["BoxErectorSystemState"] = "boxerector/systemState";
    ApplicationTopic["BoxErectorOperationalState"] = "boxerector/operationalState";
    ApplicationTopic["BoxErectorPowerRequest"] = "boxerector/robot_power/request";
    ApplicationTopic["ConveyorManualStart"] = "conveyor/manualStart";
    ApplicationTopic["PalletConfigUpdated"] = "palletizer/pallet_config_updated";
    ApplicationTopic["SelectGripper"] = "palletizer/selectGripper";
    ApplicationTopic["GripperSelected"] = "palletizer/gripperSelected";
    ApplicationTopic["RestartCore"] = "restartCore";
    ApplicationTopic["RestartEngine"] = "restartEngine";
    ApplicationTopic["LeftBayStatus"] = "palletizer/leftBayStatus";
    ApplicationTopic["RightBayStatus"] = "palletizer/rightBayStatus";
})(ApplicationTopic = exports.ApplicationTopic || (exports.ApplicationTopic = {}));
class Application {
    constructor(ip, mqtt_port, api_port = 8001, use_websockets = false, on_mqtt_connect) {
        this.message_handlers = {};
        this.message_handler_id = 0;
        this.version = '';
        this.last_log_time = new Date();
        this.init_time = new Date();
        const broker_uri = (use_websockets ? 'ws://' : 'tcp://') + ip + ':' + String(mqtt_port);
        this.api = new api_1.API(ip, api_port);
        const options = { clientId: 'libapi-' + (0, uuid_1.v4)() };
        this.state = {
            operational_state: (0, structs_1.default_op_state)(),
        };
        this.information = [];
        this.systemState = { Title: 'System Status', Items: {} };
        this.boxErectorSystemState = { Title: 'None', Items: {} };
        this.genericState = { Title: 'None', Items: {} };
        if (this.api.isWebDeployment()) {
            this.mqttClient = {
                subscribe: function (topic) {
                    console.log('wanted to subscribe to ' + topic);
                },
                publish: function (topic, msg) {
                    console.log('wanted to publish ' + topic, msg.toString());
                },
            };
        }
        else {
            this.mqttClient = mqtt_1.default.connect(broker_uri, options);
            this._initMqttClient(on_mqtt_connect);
        }
        const my = this;
        this.alert = {
            error: function (pText) {
                return my._pushAlert(structs_1.InformationType.Error, pText);
            },
            warn: function (pText) {
                return my._pushAlert(structs_1.InformationType.Warning, pText);
            },
            info: function (pText) {
                return my._pushAlert(structs_1.InformationType.Status, pText);
            },
        };
    }
    _triggerDummyButton(pIndex) {
        const lTopic = ApplicationTopic.Root + `dummy/${pIndex}`;
        this.mqttClient.publish(lTopic, `Trigger ${pIndex}`);
    }
    setEstopState(pEstop) {
        this.mqttClient.publish(ApplicationTopic.Estop, JSON.stringify(pEstop), {
            retain: true,
        });
    }
    _publishFullState() {
        this.mqttClient.publish(ApplicationTopic.State, JSON.stringify(this.state), { retain: true });
    }
    setAuxText(txt) {
        this.state.operational_state.auxiliary_text = txt;
        this._publishFullState();
    }
    setPalletizerMode(pManualModeOn) {
        const lOnOff = pManualModeOn ? 1 : 0;
        this.mqttClient.publish(ApplicationTopic.PalletizerMode, JSON.stringify(lOnOff), {
            retain: true,
        });
    }
    registerMQTTHandler(hdlr) {
        const id = this.message_handler_id++;
        this.message_handlers[id] = hdlr;
        return id;
    }
    deregisterMQTTHandler(id) {
        if (id in this.message_handlers)
            delete this.message_handlers[id];
    }
    setState(st) {
        this.mqttClient.publish(ApplicationTopic.State, JSON.stringify(st), {
            retain: true,
        });
        return;
    }
    setRobotState(st) {
        if (!structs_1.PalletizerStatus[st])
            throw Error('Invalid PalletizerStatus');
        this.state.operational_state.status = st;
        this._publishFullState();
    }
    log(t, ...args) {
        const now = new Date();
        const info = {
            Type: t,
            Description: (0, utils_1.join_args)(...args),
            TimeStamp: (0, structs_1.getInfoTimeStamp)(this.init_time, this.last_log_time, now),
        };
        this.last_log_time = now;
        return this.api.InfoLogs.push(info);
    }
    info(...args) {
        this.log(structs_1.InformationType.Status, ...args);
    }
    warn(...args) {
        this.log(structs_1.InformationType.Warning, ...args);
    }
    error(...args) {
        this.log(structs_1.InformationType.Error, ...args);
    }
    _pubSystemState() {
        throw new Error('deprecated');
        // this.mqttClient.publish(
        //   ApplicationTopic.SystemState,
        //   JSON.stringify(this.systemState),
        //   { retain: true }
        // );
    }
    setSystemState(pItems) {
        this.api.StatusItems.push(pItems);
        // this.systemState.Items = { ...this.systemState.Items, ...pItems };
        // this._pubSystemState();
    }
    setGenericState(pKey, pItems) {
        if (!(pKey in this.genericState))
            this.genericState[pKey] = {};
        this.genericState[pKey] = { ...this.genericState[pKey], ...pItems };
        this._pubGenericState();
    }
    modifyGenericState(pKey, pHandler) {
        if (!(pKey in this.genericState))
            this.genericState[pKey] = {};
        this.genericState[pKey] =
            pHandler(this.genericState[pKey]) || this.genericState[pKey];
        this._pubGenericState();
    }
    clearGenericState() {
        this.genericState = {};
    }
    clearLeftBayStatus() {
        this.mqttClient.publish(ApplicationTopic.LeftBayStatus, '', { retain: true });
    }
    clearRightBayStatus() {
        this.mqttClient.publish(ApplicationTopic.RightBayStatus, '', { retain: true });
    }
    _pubGenericState() {
        this.mqttClient.publish(ApplicationTopic.OperationalState, JSON.stringify(this.genericState), { retain: true });
    }
    async start_manual_mode() {
        const cm = {
            control_type: structs_1.ControlType.ManualMode,
            params: null,
        };
        return this.api.Commands.send(cm);
    }
    async end_manual_mode() {
        const cm = {
            control_type: structs_1.ControlType.ExitManualMode,
            params: null,
        };
        return this.api.Commands.send(cm);
    }
    async get_position(tcp = structs_1.CALIB_TCP_INDEX.Box) {
        const cm = {
            control_type: structs_1.ControlType.GetPosition,
            params: { tcp: tcp },
        };
        return this.api.Commands.send(cm).then(d => d.data);
    }
    async test_position(tcp, pallet_dimensions, box_dimensions, position_type = 'Testing', tuning_difference = [0, 0, 0, 0, 0, 0]) {
        const cm = {
            control_type: structs_1.ControlType.TestPosition,
            params: {
                tcp: tcp,
                pallet_dimensions: pallet_dimensions,
                box_dimensions: box_dimensions,
                position_type: position_type,
                tuning_difference: tuning_difference,
            },
        };
        return this.api.Commands.send(cm).then(d => d.data);
    }
    // begin_calibration() {
    //   const cm: ControlMessage = {
    //     control_type: ControlType.Calibrate,
    //     params: {},
    //   };
    //   this.mqttClient.publish(ApplicationTopic.Control, JSON.stringify(cm));
    // }
    startScanning(pCreatingBox) {
        const cmsg = {
            control_type: structs_1.ControlType.StartScanning,
            params: { creating: pCreatingBox },
        };
        return this.api.Commands.send(cmsg);
    }
    clearPendingSKUScan(pCurrentPending) {
        const keys = Object.keys(pCurrentPending);
        const lNew = {};
        for (let k = 0; k < keys.length; k++) {
            lNew[keys[k]] = '';
        }
        this.mqttClient.publish(ApplicationTopic.PendingSKUScan, JSON.stringify(lNew));
    }
    clearInvalidSKUScan(pCurrentInvalid) {
        const keys = Object.keys(pCurrentInvalid);
        const lNew = {};
        for (let k = 0; k < keys.length; k++) {
            lNew[keys[k]] = '';
        }
        this.mqttClient.publish(ApplicationTopic.InvalidSKUScan, JSON.stringify(lNew));
    }
    clearBPM() {
        this.mqttClient.publish(ApplicationTopic.OperationalState, JSON.stringify(''));
    }
    restartCore() {
        this.mqttClient.publish(ApplicationTopic.RestartCore, JSON.stringify(''));
    }
    restartEngine() {
        this.mqttClient.publish(ApplicationTopic.RestartEngine, JSON.stringify(''));
    }
    openClampGripper() {
        const cmsg = {
            control_type: structs_1.ControlType.OpenClampGripper,
            params: null,
        };
        return this.api.Commands.send(cmsg);
    }
    runInfeedManual() {
        this.mqttClient.publish(ApplicationTopic.ConveyorManualStart, JSON.stringify(1));
    }
    start(pStartBay, pPalletIdxs) {
        const cmsg = {
            control_type: structs_1.ControlType.Start,
            params: { start_bay: pStartBay, pallet_start_idxs: pPalletIdxs },
        };
        return this.api.Commands.send(cmsg);
        // this.mqttClient.publish(ApplicationTopic.Control, JSON.stringify(cmsg));
    }
    async pause() {
        const cmsg = {
            control_type: structs_1.ControlType.Pause,
            params: null,
        };
        return this.api.Commands.send(cmsg);
        // this.mqttClient.publish(ApplicationTopic.Control, JSON.stringify(cmsg));
    }
    async stop() {
        const cmsg = {
            control_type: structs_1.ControlType.Stop,
            params: null,
        };
        return this.api.Commands.send(cmsg);
        // this.mqttClient.publish(ApplicationTopic.Control, JSON.stringify(cmsg));
    }
    async home() {
        const cmsg = {
            control_type: structs_1.ControlType.Home,
            params: null,
        };
        return this.api.Commands.send(cmsg);
        // this.mqttClient.publish(ApplicationTopic.Control, JSON.stringify(cmsg));
    }
    unlockLockDoor(pNewStatus) {
        this.mqttClient.publish(ApplicationTopic.AccessRequest, JSON.stringify(pNewStatus), {
            retain: true,
        });
    }
    selectGripper(pGripperName, pTcp) {
        this.mqttClient.publish(ApplicationTopic.SelectGripper, JSON.stringify({ name: pGripperName, tcp: pTcp }));
    }
    _pushAlert(pLevel, pDetail) {
        const lUUID = (0, uuid_1.v4)();
        this.mqttClient.publish(ApplicationTopic.Alert, JSON.stringify({
            level: pLevel,
            detail: String(pDetail),
            uuid: lUUID,
        }));
        return lUUID;
    }
    _initMqttClient(pOnConnect) {
        const my = this;
        const client = my.mqttClient;
        client.on('error', (e) => {
            console.log(e);
        });
        client.on('connect', () => {
            Object.values(ApplicationTopic).forEach((t) => {
                client.subscribe(t, () => {
                    if (ApplicationTopic.State === t)
                        client.publish(ApplicationTopic.StateRequest, 'state_req');
                });
            });
            if (pOnConnect)
                pOnConnect(client);
        });
        client.on('message', (t, buf) => {
            const msg_str = buf.toString();
            Object.values(my.message_handlers).forEach(h => h(t, msg_str));
        });
    }
}
exports.Application = Application;
